import styled from "styled-components";
import PropTypes from "prop-types";

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--mainColorOpacity30);
    padding: 20px;
    overflow: hidden;
    
    @media screen and (max-width: 992px) {
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
    }
`;

export default function BoardBox({
    children,
}) {
    return (
        <Container>
            {children}
        </Container>
    )
}

BoardBox.propTypes = {
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};
